import FeedbackTableContainer from "../../Component/Feedback/FeedbackTable"

const FeedbackTable = () => {
  return (
    <div className='page-body'>
      <FeedbackTableContainer />
    </div>
  )
}

export default FeedbackTable